import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
    selector: 'snackbar-go-to-order',
    templateUrl: './snackbar-go-to-order.component.html',
    styleUrls: ['./snackbar-go-to-order.component.scss'],
    standalone: false
})
export class snackbarGoToOrder  {

  constructor(
    private snackBarRef: MatSnackBarRef<snackbarGoToOrder>,
    private router: Router,
    @Inject(MAT_SNACK_BAR_DATA) public orderId: number
  ) {}

  navigateToOrder() {
    this.snackBarRef.dismiss();
    this.router.navigate(['/sales/orders/details', this.orderId]);
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
